import { isFloatMatch } from '@impuls-coach/util-is';
import { ValidationError } from 'components/hoc/withValidation';
import i18n from 'helper/i18n';
import { sanitizeFloat } from 'helper/sanitize';
import { VALIDATE_IS_NOT_ALLOWED, VALIDATE_IS_NOT_RECOMMENDED } from 'helper/validator';

const settings = {
	overallMin: 20,
	overallMax: 200,
	warningLower: 20,
	warningUpper: 35,
};

export const codes = {
	empty: 1,
	invalidFormat: 2,
	exceedsOverall: 3,
	withinWarning: 4,
};

export default function weightValidatorFactory(inputValue: string): Promise<ValidationError | undefined> {
	return new Promise((resolve: Function, reject: Function) => {
		const toVerify: string = inputValue.toString();

		if (toVerify === '') {
			return resolve();
		}

		if (!isFloatMatch(toVerify)) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.anamnesis.determineWeight.validation.invalidFormat'),
			});
			return;
		}

		const value = parseFloat(inputValue);

		if (value <= settings.overallMin || value > settings.overallMax) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.anamnesis.determineWeight.validation.impossibleToTakePart'),
			});
			return;
		}

		if (value < settings.warningUpper && value >= settings.warningLower) {
			reject({
				type: VALIDATE_IS_NOT_RECOMMENDED,
			});
			return;
		}

		resolve();
	});
}

export const exceedsTenPercentDifference = (currentWeight: number, challangingWeight: number): boolean => {
	const diff = Math.abs(currentWeight - parseFloat(`${challangingWeight}`)); // in kg
	const tenPercent = (currentWeight / 100) * 10; // in kg

	return diff >= tenPercent;
};

export const sanitize = (value: string): string => {
	return sanitizeFloat(value, 3);
};
